import { Rendition } from "@omni/types/components/image/rendition.type";
import {
    FrontEndImage,
    ResponsiveImage,
    ResponsiveImageVariant
} from "@omni/types/components/image/responsiveImage.type";
import { isDefined } from "@omni/utils/helper.utils";

export enum MediaSettings {
    Mobile = "(width < 768px)"
}

const toSrcSet = (renditions: Array<Rendition>) => {
    return renditions
        .map((rendition) => `${rendition.source} ${rendition.width}w`)
        .join(", ");
};

export const getFrontEndImage = ({
    image,
    mediaSettings
}: {
    image?: ResponsiveImage<ResponsiveImageVariant.Core>;
    mediaSettings: MediaSettings | null;
}): FrontEndImage | null => {
    if (!image?.renditions || image.renditions.length === 0) {
        return null;
    }
    const { width, height, renditions } = image;

    const srcSet = isDefined(renditions) ? toSrcSet(renditions) : null;

    return {
        srcSet: srcSet,
        width: width ?? null,
        height: height ?? null,
        media: mediaSettings
    } satisfies FrontEndImage;
};
